import { readableColor } from "polished";
import { useAuth } from "../../contexts/AuthContext";
import { useTheme } from "../../contexts/ThemeContext";

export const ResumeCourses = ({ children }) => {
  const theme = useTheme();
  const { lang } = useAuth();

  console.log(theme.colors);

  return (
    <>
      <div
        className="wrapper fon-sec-car !p-12 "
        style={{ backgroundColor: theme.colors.backgroundColorBody }}
      >
        {/* <div className="container"> */}
        <div className="container mx-auto max-w-[1420px] ">
          <div className="col-md-12">
            <div className="row d-flex justify-content-center ">
              {/* <div className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 gap-6 tablet:gap-19 justify-items-center">
                {children}
              </div> */}
              <h1
                className="tit-color font-jost font-semibold"
                style={{
                  color: readableColor(
                    theme.mode === "light" ? "#F5F5F5" : "#1F3250",
                  ),
                }}
              >
                {lang["Home"].title}
              </h1>
              <div className="mt-12 !px-0 grid grid-cols-1 min-[700px]:grid-cols-2 laptop:grid-cols-3 min-[1380px]:grid-cols-4 gap-10 tablet:gap-12 laptop:gap-16 justify-items-center">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
